/**
 * Convert base64url-encoded VAPID key to Uint8Array
 *
 * VAPID keys use base64url encoding (RFC 4648 §5) which uses `-` and `_`
 * instead of `+` and `/`. This function converts to standard base64,
 * adds padding if needed, and returns a Uint8Array for the Push API.
 */
export const convertBase64UrlToUint8Array = (
  base64url: string
): BufferSource => {
  const padding = '='.repeat((4 - (base64url.length % 4)) % 4);
  const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return new Uint8Array([...rawData].map(c => c.codePointAt(0) ?? 0));
};
